/* eslint-disable no-loop-func */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable default-param-last */
/* eslint-disable camelcase */

/**
 * @module Face module
 */

import { detect } from 'detect-browser';
import { proxy } from 'comlink';
import {
  isValidInternal,
  prividAgePredict,
  FHE_enrollOnefa,
  FHE_predictOnefa,
  antispoofCheck,
  createImages,
  getDebugType,
  getIsSIMD,
  iOS,
  isMobileFunc,
  scanDocument,
  deleteUUID,
  getPortraitBase64,
  isValidBarCode,
  printLogs,
  setDefaultCameraDeviceId,
  getDefaultCameraDeviceId,
  prividFaceISO,
  getStatusMessage,
  prividFaceCompareLocal,
  getFrontDocumentStatusMessage,
  getBackDocumentStatusMessage,
  loadAntispoof,
  convertCroppedImage,
} from './utils';
import { CameraFaceMode, ImageType, FaceStatuses, Base64, DocType, LOGTYPE, FacingMode } from './types';
import { facingMode } from './constants';
import { wasmModule } from './envUtils';
import { getCameraList, getVideoConstraints } from './cameraUtils';
// eslint-disable-next-line import/no-cycle
import { isAntispoofLoaded, loadAntiSpoofModules } from '.';

let videoElement: string = null;
let faceMode: CameraFaceMode = CameraFaceMode.front;
let mediaDevice: string | null = null;
let mediaDevices: MediaDeviceInfo[] = null;
let mediaStream: MediaStream = null;
const ENROLL_REQUIRED_IMAGES = 10;
const PREDICT_REQUIRED_IMAGES = 1;
let isSimd = false;
const debugType = getDebugType();

const isDebugWithImages = ['900', '901', '902', '903'].includes(debugType);
let currentOperation: any = null;

const cameraHeight = 1440;
const cameraWidth = 2560;

const cameraLowResHeight = 1080;
const cameraLowResWidth = 1920;

const mobileCameraResWidth = 2560;
const mobileCameraResHeight = 1440;

// let globalCanvas: HTMLCanvasElement | null = null;
// let globalImageData: ImageData | null = null;

getIsSIMD().then((simd) => (isSimd = simd));

let privid_wasm_result: any = (operation: string, id: string, response_str: any) => {};
// export function privid_wasm_result(operation: any, id: any, response_str: any) {
//   console.log('-------------IT IS FROM NPM PACKAGE------------------');
//   console.log(cb);
//   console.log('-------------IT IS FROM NPM PACKAGE------------------');

//   if ( operation == 'is_valid' ) {
//       const { result } = JSON.parse(response_str)
//       return;
//   }
//   const { result } = JSON.parse(response_str)
//   cb(result);

//   console.log('[JS RESPONSE] : Operation = ', operation);
//   console.log('[JS RESPONSE] : Transaction Id = ', id);
//   console.log('[JS RESPONSE] : Response Str = ', response_str);
//   console.log('[JS RESPONSE] : Response Str = ', JSON.parse(response_str));
// };

const createCallbackIsValid =
  (callback: any, livenessCheck?: number) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      const returnValue = JSON.parse(response_str);
      if (operation === 'is_valid') {
        callback({ status: FaceStatuses.WASM_RESPONSE, returnValue, livenessCheck });
      }
    }
  };

const createCallbackEnroll =
  (callback: any, portrait?: Base64) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      const returnValue = JSON.parse(response_str);
      if (operation === 'enroll') {
        if (returnValue.status === 0) {
          callback({ status: FaceStatuses.WASM_RESPONSE, returnValue, portrait: portrait || '' });
        } else {
          callback({ status: FaceStatuses.WASM_RESPONSE, returnValue });
        }
      }
    }
  };

const createCallbackPredict =
  (callback: any, livenessCheck?: number) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      const returnValue = JSON.parse(response_str);
      if (operation === 'predict') {
        callback({ status: FaceStatuses.WASM_RESPONSE, returnValue, livenessCheck });
      }
    }
  };

const createResultFaceISO =
  (callback: any, portrait?: Base64) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      const returnValue = JSON.parse(response_str);
      if (operation === 'face_iso') {
        callback({ status: FaceStatuses.WASM_RESPONSE, returnValue, portrait: portrait || '' });
      }
    }
  };

const createCallbackFrontDlScan =
  (callback: any, canvas: HTMLCanvasElement) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      if (operation === 'document_model') {
        const returnValue = JSON.parse(response_str);
        callback({
          status: FaceStatuses.WASM_RESPONSE,
          returnValue: { ...returnValue, status_message: getFrontDocumentStatusMessage(returnValue?.op_status) },
        });
        if (returnValue?.op_status === 0) {
          releaseCanvas(canvas);
        }
      }
    }
  };

const createCallbackBackDlScan =
  (callback: any, canvas: HTMLCanvasElement) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      const returnValue = JSON.parse(response_str);
      if (operation === 'is_valid_barcode') {
        // GAN, if Missing Field = undefined
        const requiredData = {
          firstName: returnValue.firstName,
          lastName: returnValue.lastName,
          dateOfBirth: returnValue.dateOfBirth,
          streetAddress1: returnValue.streetAddress1,
          state: returnValue.state,
          city: returnValue.city,
          postalCode: returnValue.postalCode,
          country: returnValue.issuingCountry,
        };
        callback({
          status: FaceStatuses.WASM_RESPONSE,
          returnValue: { ...returnValue, status_message: getBackDocumentStatusMessage(returnValue?.op_status) },
          requiredData,
        });
        if (returnValue.op_status === 0) {
          releaseCanvas(canvas);
        }
      }
    }
  };

const createCallbackDelete = (callback: any) => (operation: string, id: string, response_str: any) => {
  const isResponse = response_str.length > 0;
  printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
  printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
  printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

  if (isResponse) {
    const returnValue = JSON.parse(response_str);
    if (operation === 'delete') {
      callback({ status: FaceStatuses.WASM_RESPONSE, returnValue });
    }
  }
};

const createResultPredictAge =
  (callback: any, livenessCheck?: number, portrait?: Base64) => (operation: string, id: string, response_str: any) => {
    const isResponse = response_str.length > 0;
    printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
    printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

    if (isResponse) {
      const returnValue = JSON.parse(response_str);
      if (operation === 'estimate_age') {
        callback({ status: FaceStatuses.WASM_RESPONSE, returnValue, livenessCheck, portrait });
      }
    }
  };

const createCallbackFaceCompare = (callback: any) => (operation: string, id: string, response_str: any) => {
  const isResponse = response_str.length > 0;
  printLogs('================[JS RESPONSE]: response_str', isResponse ? JSON.parse(response_str) : '', LOGTYPE.LOG);
  printLogs('[JS RESPONSE]: operation', operation || 'null', LOGTYPE.LOG);
  printLogs('[JS RESPONSE]: id', id || 'null', LOGTYPE.LOG);

  if (isResponse) {
    if (operation === 'compare_files') {
      const returnValue = JSON.parse(response_str);
      callback({ status: FaceStatuses.WASM_RESPONSE, returnValue });
    }
  }
};

export const deleteUser = (uuid: string, callback: any) => {
  printLogs('----1-----', '', debugType);
  privid_wasm_result = createCallbackDelete(callback);
  printLogs('----2-----', '', debugType);

  const cb: any = proxy(privid_wasm_result);
  printLogs('----3-----', '', debugType);

  deleteUUID(uuid, cb);
  printLogs('----4-----', '', debugType);
};

const openCameraMobile = async (
  domElement: string,
  requestFaceMode: CameraFaceMode | null = null,
  canvasResolution?: { width: number; height: number },
  requireHD = false,
  isDocumentScan?: boolean,
): Promise<{
  stream: MediaStream | null;
  devices: MediaDeviceInfo[] | null;
  faceMode: CameraFaceMode | null;
  settings: MediaTrackSettings | null;
  status: boolean;
  errorMessage?: string | null;
  capabilities: MediaTrackCapabilities | null;
}> => {
  try {
    videoElement = domElement;
    printLogs('Opening Camera on Mobile', '', debugType);
    let devices: MediaDeviceInfo[] = await navigator.mediaDevices.enumerateDevices();
    devices = devices.filter((d) => d.kind === 'videoinput');
    console.log('Video Devices: ', devices);
    const mediaDevices = devices;
    // if (requestFaceMode) {
    //   const regex = requestFaceMode === CameraFaceMode.back ? /back/gi : /front/gi;
    //   const filteredDevices = devices.filter((d) => regex.test(d.label));
    //   mediaDevices = filteredDevices.length ? filteredDevices : devices;
    //   console.log('Filtered devices: ', filteredDevices);
    // }
    // const { name: browserName, os } = detect();
    const deviceCapabilites = getDefaultDevice(devices, mediaDevices[0].deviceId);
    const resolutionWidth = canvasResolution?.width || cameraLowResWidth; // (iOS() || ['iOS'].includes(os) ? cameraLowResWidth : cameraWidth);
    const resolutionHeight = canvasResolution?.height || cameraLowResHeight; // (iOS() || ['iOS'].includes(os) ? cameraLowResHeight : cameraHeight);
    let stream: MediaStream;

    let hasError = true;
    while (hasError) {
      try {
        const constraints = {
          audio: false,
          video: {
            // deviceId: mediaDevices[0].deviceId,
            width: { ideal: resolutionWidth },
            facingMode: facingMode[faceMode] || 'user',
            height: { ideal: resolutionHeight },
            advance: [
              {
                focusMode: 'continuous',
                resizeMode: 'crop-and-scale',
                aspectRatio: 1.7777777778,
              },
              {
                focusMode: 'continuous',
                resizeMode: 'crop-and-scale',
                zoom: 1,
              },
            ],
          },
        };
        // printLogs('mobile constraints: ', constraints, debugType, LOGTYPE.LOG);
        // stream = await navigator.mediaDevices.getUserMedia(constraints);
        // @ts-ignore
        const videoConstraint = getVideoConstraints(
          await getCameraList(faceMode === 'back'),
          // @ts-ignore
          facingMode[faceMode],
          requireHD,
          isDocumentScan,
        );
        console.log('videoConstraint:', videoConstraint);
        stream = await navigator.mediaDevices.getUserMedia(
          // @ts-ignore
          videoConstraint,
        );

        hasError = false;
      } catch (e) {
        console.log('Mobile er:', { error: e });
        // hasError = false;
      }
    }

    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities();
    const settings = track.getSettings();
    console.log('capabilities: ', capabilities);
    console.log('settings: ', settings);

    const element: HTMLVideoElement = document.getElementById(domElement) as HTMLVideoElement;
    element.srcObject = stream;
    element.play();

    await new Promise((resolve) => (element.onplaying = resolve));
    mediaStream = stream;
    return { status: true, stream, devices, faceMode, settings, capabilities };
  } catch (e) {
    printLogs('Error:', e, debugType);
    printLogs('Error:', e, debugType, LOGTYPE.ERROR);
    return null;
  }
};

/**
 * @ignore
 */
const openCameraMacSafari = async (
  domElement: string,
  deviceId: string | null = null,
  canvasResolution: { width: number; height: number } | null = { width: cameraWidth, height: cameraHeight },
  requireHD = false,
): Promise<{
  stream: MediaStream | null;
  devices: MediaDeviceInfo[] | null;
  faceMode: CameraFaceMode | null;
  settings: MediaTrackSettings | null;
  status: boolean;
  errorMessage?: string | null;
  capabilities: MediaTrackCapabilities | null;
}> => {
  try {
    videoElement = domElement;
    printLogs('Opening Camera on Mac Safari', '', debugType);
    let devices: MediaDeviceInfo[] = await navigator.mediaDevices.enumerateDevices();
    devices = devices.filter((d) => d.kind === 'videoinput');

    const defaultDeviceId = getDefaultCameraDeviceId();
    const externalDeviceId =
      devices.length > 1 ? devices.find((device) => !device.label.includes('FaceTime')) : devices[0];
    const isDefaultDeviceAvailable = devices.find((device) => defaultDeviceId === device.deviceId);
    mediaDevice = deviceId || (isDefaultDeviceAvailable ? defaultDeviceId : externalDeviceId.deviceId);

    setDefaultCameraDeviceId(mediaDevice);

    const deviceCapabilites = getDefaultDevice(devices, mediaDevice);
    const resolution = requireHD
      ? canvasResolution?.width || Math.min(deviceCapabilites[0]?.width?.max || cameraWidth, cameraWidth)
      : canvasResolution?.width || Math.min(deviceCapabilites[0]?.width?.max || cameraLowResWidth, cameraLowResWidth);
    const constraints = {
      audio: false,
      video: {
        deviceId: deviceCapabilites[0].deviceId,
        width: { ideal: resolution },
        height: canvasResolution?.height ? { ideal: canvasResolution?.height } : undefined,

        // advance: [{ width: { ideal: 2560 }, height: { ideal: 1440 } }],
      },
    };

    const stream: MediaStream = await navigator.mediaDevices.getUserMedia(constraints);
    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities();
    const settings = track.getSettings();
    printLogs('capabilities: ', capabilities, debugType, LOGTYPE.LOG);
    printLogs('settings: ', settings, debugType, LOGTYPE.LOG);

    const element: HTMLVideoElement = document.getElementById(domElement) as HTMLVideoElement;
    element.srcObject = stream;
    element.play();

    await new Promise((resolve) => (element.onplaying = resolve));
    mediaStream = stream;

    return { status: true, stream, devices, faceMode, settings, capabilities };
  } catch (e) {
    printLogs('Error while getAccessToCamera', e, debugType, LOGTYPE.ERROR);
    return null;
  }
};

const openCameraFirefox = async (
  domElement: string,
  canvasResolution: { width: number; height: number } | null = { width: cameraWidth, height: cameraHeight },
  requireHD = false,
): Promise<{
  stream: MediaStream | null;
  devices: MediaDeviceInfo[] | null;
  faceMode: CameraFaceMode | null;
  settings: MediaTrackSettings | null;
  status: boolean;
  errorMessage: string | null;
  capabilities: MediaTrackCapabilities | null;
}> => {
  videoElement = domElement;
  await navigator.mediaDevices.getUserMedia({ audio: false, video: true });
  console.log('Firefox function here.....');
  try {
    let devices: MediaDeviceInfo[] = [];

    devices = await navigator.mediaDevices.enumerateDevices();
    devices = devices.filter((d) => d.kind === 'videoinput');
    printLogs('=====> MY DEVICES??? ', devices, debugType);

    if (devices.length === 0) {
      throw new Error('NO_CAMERA');
    }

    const constraints = {
      audio: false,
      video: {
        width: { ideal: canvasResolution?.width || requireHD ? cameraWidth : cameraLowResWidth },
        height: canvasResolution?.height ? { ideal: canvasResolution?.height } : undefined,
      },
      aspectRatio: 1.7777777778,
      focusMode: 'continuous',
      facingMode: facingMode[faceMode] || 'user',
    };

    const stream: MediaStream = await navigator.mediaDevices.getUserMedia(constraints);

    const track = stream.getVideoTracks()[0];
    const settings = track.getSettings();
    const capabilities = track?.getCapabilities ? track.getCapabilities() : stream;

    printLogs('settings: ', settings, debugType);

    const element: HTMLVideoElement = document.getElementById(domElement) as HTMLVideoElement;
    element.srcObject = stream;
    element.play();

    await new Promise((resolve) => (element.onplaying = resolve));
    mediaStream = stream;
    mediaDevices = devices;
    // @ts-ignore
    return { status: true, errorMessage: '', stream, devices, faceMode, settings, capabilities };
  } catch (e) {
    if (parseInt(debugType, 10) >= 2) {
      printLogs('Error while getAccessToCamera', e, debugType, LOGTYPE.ERROR);
    }

    return null;
  }
};

/**
 * This function open camera, and returns the stream, current faceMode and the list of available media devices
 * @category Face
 * @param domElement id of the video tag
 * @param requireHD
 * @param deviceId
 * @param requestFaceMode
 * @param canvasResolution
 * @param isDocumentScan
 */
export const openCamera = async (
  domElement: string,
  requireHD: boolean,
  deviceId: string | null = null,
  requestFaceMode: CameraFaceMode | null = null,
  canvasResolution?: { width: number; height: number } | null,
  isDocumentScan?: boolean,
): Promise<{
  stream: MediaStream | null;
  devices: MediaDeviceInfo[] | null;
  faceMode: CameraFaceMode | null;
  settings: MediaTrackSettings | null;
  status: boolean;
  errorMessage?: string | null;
  capabilities: MediaTrackCapabilities | null;
}> => {
  videoElement = domElement;
  faceMode = requestFaceMode;
  const { name: browserName, os } = detect();

  await navigator.mediaDevices.getUserMedia({ video: true, audio: false }).then((mediaStream) => {
    const stream = mediaStream;
    const tracks = stream.getTracks();
    console.log('tracks to stop', tracks);
    tracks.forEach((track) => track.stop());
  });

  // Firefox
  if (browserName === 'firefox') {
    console.log('==== Firefox open camera');
    return openCameraFirefox(domElement, canvasResolution, requireHD);
  }

  // Mobile
  if (iOS() || ['iOS', 'android', 'Android OS'].includes(os)) {
    console.log('==== Mobile open camera!');
    return openCameraMobile(domElement, requestFaceMode, canvasResolution, requireHD, isDocumentScan);
  }

  // Mac Safari Browser
  if (os === 'Mac OS' && browserName === 'safari') {
    console.log('==== Mac safari open camera!');
    return openCameraMacSafari(domElement, deviceId, canvasResolution, requireHD);
  }

  try {
    let devices: MediaDeviceInfo[] = [];

    devices = await navigator.mediaDevices.enumerateDevices();
    devices = devices.filter((d) => d.kind === 'videoinput');
    // console.log('====> video input device available', devices);

    printLogs('=====> MY DEVICES??? ', devices, debugType);
    if (devices.length === 0) {
      throw new Error('NO_CAMERA');
    }

    let defaultDeviceId = getDefaultCameraDeviceId();
    if (deviceId) {
      defaultDeviceId = deviceId;
    }

    if (!mediaDevice) {
      if (deviceId) {
        mediaDevice = deviceId;
      } else {
        const isDefaultDeviceAvailable = devices.find((device) => defaultDeviceId === device.deviceId);
        mediaDevice = isDefaultDeviceAvailable ? defaultDeviceId : devices[0].deviceId;
      }
    }

    const deviceCapabilites = getDefaultDevice(devices, mediaDevice);
    console.log('========= Opens Camera ======== ');
    const getBestResolution = async () => {
      let resolution =
        canvasResolution?.width || Math.min(deviceCapabilites[0]?.width?.max || cameraWidth, cameraWidth);
      let hasError = true;
      let constraints = {
        audio: false,
        video: {
          deviceId: deviceCapabilites[0].deviceId,
          width: { min: resolution, max: resolution },
          height: canvasResolution?.height ? { ideal: canvasResolution?.height } : undefined,
        },
      };

      let stream: MediaStream;
      while (hasError) {
        try {
          stream = await navigator.mediaDevices.getUserMedia(constraints);
          if (stream) hasError = false;
        } catch (e) {
          resolution = getTheNextResolutionAvailable(resolution);
          constraints = {
            ...constraints,
            video: { ...constraints.video, width: { min: resolution, max: resolution } },
          };
        }
      }

      printLogs('bestconstraints: ', constraints, debugType);
      return stream;
    };

    let stream: MediaStream;

    if (requireHD) {
      let hasError = true;
      let resolution =
        canvasResolution?.width || Math.min(deviceCapabilites[0]?.width?.max || cameraWidth, cameraWidth);
      let constraints = {
        audio: false,
        deviceId: mediaDevice,
        video: {
          width: { min: resolution, max: resolution },
          // height: { min: cameraHeight, max: cameraHeight },
        },
      };
      while (hasError) {
        try {
          stream = await navigator.mediaDevices.getUserMedia(constraints);
          if (stream) hasError = false;
        } catch (e) {
          console.log('require HD Error:', e);
          resolution = getTheNextResolutionAvailable(resolution);
          constraints = {
            ...constraints,
            video: { ...constraints.video, width: { min: resolution, max: resolution } },
          };
        }
      }
    } else {
      stream = await getBestResolution();
    }

    // console.log('video tracks?', stream.getVideoTracks());
    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities();
    const settings = track.getSettings();

    setDefaultCameraDeviceId(settings?.deviceId);
    // printLogs('capabilities: ', capabilities, debugType);
    // printLogs('settings: ', settings, debugType);
    console.log('capabilities: ', capabilities);
    console.log('settings: ', settings);

    const element: HTMLVideoElement = document.getElementById(domElement) as HTMLVideoElement;
    element.srcObject = stream;
    element.play();

    await new Promise((resolve) => (element.onplaying = resolve));
    mediaStream = stream;
    mediaDevices = devices;

    return { status: true, stream, devices, faceMode, settings, capabilities };
  } catch (e) {
    console.log('Error while getAccessToCamera', e);
    return null;
  }
};

/**
 * This function open camera, and returns the stream, current faceMode and the list of available media devices
 * @category Face
 * @param domElement id of the video tag
 */
export const closeCamera = async (element: string | undefined) => {
  try {
    const video = element || videoElement;
    const videoEl: any = document.getElementById(video);
    if (!videoEl) return;
    const stream = videoEl?.srcObject;
    if (stream) {
      const tracks = stream?.getTracks();
      tracks?.forEach((track: MediaStreamTrack) => {
        track?.stop();
      });
      if (videoEl) {
        videoEl.srcObject = null;
      }
    }
  } catch (err) {
    console.log('____Error', err);
  }
};

const getTheNextResolutionAvailable = (currentResolution: number) => {
  console.log({ currentResolution });
  const resolutions = [2560, 1920, 1600, 1280, 1024, 960, 800, 720, 704, 640].sort((a, b) => b - a);
  return resolutions.find((e) => e < currentResolution);
};

/**
 * This function switch camera from front to back on mobile, and to another device on desktop
 * @category Face
 * @param selectedCamera Selected camera either front or back
 * @param device Selected camera ID
 * @param canvasResolution
 */
export const switchCamera = async (
  selectedCamera: CameraFaceMode | null,
  device: string,
  canvasResolution?: { width: number; height: number } | null,
): Promise<{ capabilities: MediaTrackCapabilities | null; settings: MediaTrackSettings | null } | null> => {
  if (!videoElement) return;
  let devices: MediaDeviceInfo[] = [];
  if (mediaStream) {
    mediaStream.getTracks().forEach((track) => track.stop());
  }
  devices = await navigator.mediaDevices.enumerateDevices();
  devices = devices.filter((d) => d.kind === 'videoinput');

  const deviceCapabilites = getDefaultDevice(devices, device);
  if (selectedCamera) faceMode = selectedCamera;
  const getBestResolution = async () => {
    let resolution = canvasResolution?.width || Math.min(deviceCapabilites[0]?.width?.max || cameraWidth, cameraWidth);
    let hasError = true;
    const constraints = {
      audio: false,
      video: {
        deviceId: deviceCapabilites[0].deviceId,
        width: { ideal: resolution },
        height: canvasResolution?.height ? { ideal: canvasResolution?.height } : { ideal: cameraHeight },
      },
      advance: [
        {
          focusMode: 'continuous',
          resizeMode: 'crop-and-scale',
          // @ts-ignore
          focusDistance: Math.min(deviceCapabilites[0]?.focusDistance?.max || 100, 100),
          aspectRatio: 1.7777777778,
        },
      ],
    };
    let stream: MediaStream;
    while (hasError) {
      try {
        stream = await navigator.mediaDevices.getUserMedia(constraints);
        hasError = false;
      } catch (e) {
        resolution = getTheNextResolutionAvailable(resolution);
        constraints.video = { ...constraints.video, width: { ideal: resolution } };
      }
    }
    printLogs('bestconstraints: ', constraints, debugType);
    return stream;
  };

  if (device) {
    mediaDevice = device;
    setDefaultCameraDeviceId(device);
  }

  if (selectedCamera && !device) {
    if (selectedCamera) {
      const regex = selectedCamera === CameraFaceMode.back ? /back/gi : /front/gi;
      devices = devices.filter((d) => regex.test(d.label));
    }
    const getBestResolutionWithFacingMode = async () => {
      const deviceCapabilites = getDefaultDevice(devices, devices[0].deviceId);
      const { name: browserName, os } = detect();
      const resolutionWidth =
        canvasResolution?.width || (iOS() || ['iOS'].includes(os) ? cameraLowResWidth : cameraWidth);
      const resolutionHeight =
        canvasResolution?.height || (iOS() || ['iOS'].includes(os) ? cameraLowResHeight : cameraHeight);
      let hasError = true;
      const constraints = {
        audio: false,
        video: {
          // deviceId: deviceCapabilites[0].deviceId,
          width: { ideal: resolutionWidth },
          facingMode: faceMode ? facingMode[faceMode] : 'user',
          height: { ideal: resolutionHeight },
        },
        advance: [
          {
            focusMode: 'continuous',
            resizeMode: 'crop-and-scale',
            // @ts-ignore
            focusDistance: Math.min(deviceCapabilites[0]?.focusDistance?.max || 100, 100),
            aspectRatio: 1.7777777778,
          },
        ],
      };
      let stream: MediaStream;
      while (hasError) {
        try {
          stream = await navigator.mediaDevices.getUserMedia(constraints);
          hasError = false;
        } catch (e) {
          //
        }
      }
      printLogs('bestconstraints: ', constraints, debugType);
      return stream;
    };
    try {
      // eslint-disable-next-line no-nested-ternary
      const stream: MediaStream = await getBestResolutionWithFacingMode();
      const element: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
      element.srcObject = stream;
      mediaStream = stream;
      const track = stream.getVideoTracks()[0];
      const capabilities = track?.getCapabilities ? track.getCapabilities() : null;
      const settings = track.getSettings();
      console.log('switch camera capabilities:', capabilities);
      console.log('switch camera settings:', settings);
      // eslint-disable-next-line consistent-return
      return { capabilities, settings };
    } catch (e) {
      printLogs('Error while getAccessToCamera', e, debugType, LOGTYPE.ERROR);
      await switchCamera(null, devices[0].deviceId, canvasResolution);
    }
  } else {
    try {
      // eslint-disable-next-line no-nested-ternary
      const stream: MediaStream = await getBestResolution();
      const element: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
      element.srcObject = stream;
      mediaStream = stream;
      const track = stream.getVideoTracks()[0];
      const capabilities = track?.getCapabilities ? track.getCapabilities() : null;
      const settings = track.getSettings();
      // eslint-disable-next-line consistent-return
      return { capabilities, settings };
    } catch (e) {
      printLogs('Error while getAccessToCamera', e, debugType, LOGTYPE.ERROR);
      await switchCamera(null, devices[0].deviceId, canvasResolution);
    }
  }
};

/**
 * This function applies a face captcha, it either take an image as input or take a picture using the camera, and performs face detection then returns result
 * @category Face
 * @param callback callback function to handle result
 * @param image ImageData array to perform face detection on
 *
 */

export const isValid = async (
  callback: (input: { status: FaceStatuses; result?: number; returnValue?: any }) => void,
  image?: ImageData,
  config?: any,
  livenessCheck?: boolean,
  // eslint-disable-next-line consistent-return
) => {
  let isValidConfig = { input_image_format: 'rgba' };

  if (config) {
    isValidConfig = {
      ...config,
    };
  }
  const configData = JSON.stringify(isValidConfig);
  if (image) {
    privid_wasm_result = createCallbackIsValid(callback);
    await isValidInternal(
      image.data,
      image.width,
      image.height,
      isSimd,
      debugType,
      proxy(privid_wasm_result),
      configData,
    );
    printLogs('===> isValid with image result JSON', '', debugType);
  }

  if (!videoElement) {
    printLogs('capture need the video element id', '', debugType, LOGTYPE.ERROR);
    return { result: 'error' };
  }

  const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
  printLogs('video element', videoEl, debugType);
  if (!videoEl) {
    printLogs('no video element found', '', debugType, LOGTYPE.ERROR);
    return { result: 'error' };
  }
  const height = videoEl.videoHeight;
  const width = videoEl.videoWidth;

  if (width === 0) return { result: 'error' };
  const canvas = document.createElement('canvas');
  canvas.setAttribute('id', 'test-canvas');
  canvas.setAttribute('height', `${height}`);
  canvas.setAttribute('width', `${width}`);
  // canvas.height = height;
  // canvas.width = width;

  const context: CanvasRenderingContext2D = canvas.getContext('2d');

  context.drawImage(videoEl, 0, 0);
  if (image?.width === 0) return { result: 'error' };
  const imageData = context.getImageData(0, 0, width, height);

  if (livenessCheck) {
    // if (!isAntispoofLoaded()) {
    //   await loadAntiSpoofModules();
    // }
    const result = await antispoofCheck(imageData.data, imageData.width, imageData.height);
    privid_wasm_result = createCallbackIsValid(callback, result?.livenessCheck);
    if (result?.livenessCheck === 0) {
      await isValidInternal(
        imageData.data,
        imageData.width,
        imageData.height,
        isSimd,
        debugType,
        proxy(privid_wasm_result),
        configData,
      );
    } else {
      // privid_wasm_result = createCallbackIsValid(callback);
      // @ts-ignore
      callback({ status: FaceStatuses.WASM_RESPONSE, livenessCheck: result?.livenessCheck });
    }
  } else {
    privid_wasm_result = createCallbackIsValid(callback);
    await isValidInternal(
      imageData.data,
      imageData.width,
      imageData.height,
      isSimd,
      debugType,
      proxy(privid_wasm_result),
      configData,
    );
  }
};

export const predictAge = async (
  image?: ImageData,
  callback?: (ageData?: {
    returnValue?: { faces: any };
    ageFactor?: number;
    channels?: number;
    conf_level_age?: number;
    crop_conf_score?: number;
    crop_conf_score_thr?: number;
    crop_status?: number;
    exposure?: number;
    face_blurr_var?: number;
    face_center_x?: number;
    face_center_y?: number;
    face_count?: number;
    face_height?: number;
    face_wear_eye_glass_score?: number;
    face_wear_mask_score?: number;
    face_wear_ok?: number;
    face_width?: number;
    im_height?: number;
    im_width?: number;
    image_iso_bytes?: number;
    image_iso_height?: number;
    image_iso_width?: number;
    metric_bitfield?: number;
    payload_type?: string;
    qrate?: number;
    result?: number;
    result_age?: number;
  }) => void,
  config?: { input_image_format: string },
  element?: string,
  livenessCheck?: boolean,
  returnPortrait?: boolean,
  // eslint-disable-next-line consistent-return
): Promise<void | { result: number | string; imageData?: ImageData }> => {
  let portrait: Base64;
  if (element) {
    videoElement = element;
  }
  if (image) {
    prividAgePredict(image.data, image.width, image.height, isSimd, debugType, proxy(privid_wasm_result));
  }
  if (!videoElement) {
    printLogs('capture need the video element id', '', debugType, LOGTYPE.ERROR);
    return { result: 'error' };
  }

  const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
  const height = videoEl.videoHeight;
  const width = videoEl.videoWidth;
  // eslint-disable-next-line consistent-return
  if (width === 0) return { result: 'error' };
  printLogs('------ isValid', `${height} ${width}`, debugType);
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  canvas.setAttribute('id', 'test-canvas');
  canvas.setAttribute('height', `${height}`);
  canvas.setAttribute('width', `${width}`);
  // canvas.height = height;
  // canvas.width = width;
  const context: CanvasRenderingContext2D = canvas.getContext('2d');

  if (faceMode === CameraFaceMode.front) {
    context.translate(width, 0);
    context.scale(-1, 1);
  }

  context.drawImage(videoEl, 0, 0);
  if (image?.width === 0) return { result: 'error' };
  const imageData = context.getImageData(0, 0, width, height);

  if (['900', '901', '902', '903'].includes(debugType)) {
    await createImages([imageData], ImageType.original, true);
  }

  if(returnPortrait){
    portrait =await convertCroppedImage(imageData.data, imageData.width, imageData.height);
  }

  if (livenessCheck) {
    // if (!isAntispoofLoaded()) {
    //   await loadAntiSpoofModules();
    // }
    const result = await antispoofCheck(imageData.data, imageData.width, imageData.height);
    privid_wasm_result = createResultPredictAge(callback, result?.livenessCheck, portrait);
    if (result?.livenessCheck === 0) {
      prividAgePredict(imageData.data, imageData.width, imageData.height, isSimd, debugType, proxy(privid_wasm_result));
    } else {
      // @ts-ignore
      callback({ status: FaceStatuses.WASM_RESPONSE, livenessCheck: result?.livenessCheck });
    }

  } else {
    privid_wasm_result = createResultPredictAge(callback, undefined, portrait);
    prividAgePredict(imageData.data, imageData.width, imageData.height, isSimd, debugType, proxy(privid_wasm_result));
  }
};

const isValidPhotoIDCanvas: HTMLCanvasElement = document.createElement('canvas');

export const isValidPhotoID = async (
  docType: DocType,
  callback: any = () => {},
  doPredict = true,
  image?: ImageData,
  config: { input_image_format: string; document_scan_barcode_only?: string } | null = null,
  canvasSize: { width: number; height: number } | Record<string, never> = {},
  // eslint-disable-next-line consistent-return
) => {
  console.log('________________ DOCUMENT SCAN ______________');
  const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
  let configuration;
  if (!config) {
    configuration = { input_image_format: 'rgba' };
  } else {
    configuration = config;
  }

  if (docType === DocType.PHOTO_ID_FRONT) {
    privid_wasm_result = createCallbackFrontDlScan(callback, isValidPhotoIDCanvas);
  } else {
    privid_wasm_result = createCallbackBackDlScan(callback, isValidPhotoIDCanvas);
  }

  if (image && docType === DocType.PHOTO_ID_FRONT) {
    if (doPredict) {
      configuration = JSON.stringify({
        ...configuration,
        document_check_validity: true,
        document_face_predict: true,
        document_auto_rotation: false,
      });
    } else {
      configuration = JSON.stringify({
        ...configuration,
        document_check_validity: true,
        document_face_predict: false,
        document_auto_rotation: false,
      });
    }
    console.log({ imageData: image });
    const result = await scanDocument(image, isSimd, proxy(privid_wasm_result), doPredict, configuration, debugType);
    return { imageData: image, ...result };
  }
  if (image && docType === DocType.PHOTO_ID_BACK) {
    configuration = JSON.stringify(configuration);
    const result = await isValidBarCode(image, isSimd, proxy(privid_wasm_result), configuration, debugType);
    return { imageData: image, ...result };
  }

  if (!videoElement || !videoEl) {
    printLogs('capture need the video element id', '', debugType, LOGTYPE.ERROR);
    return { result: 'error' };
  }

  const isDocument = docType === DocType.PHOTO_ID_FRONT;
  let height = canvasSize?.height || videoEl.videoHeight;
  let width = canvasSize?.width || videoEl.videoWidth;
  if (isMobileFunc()) {
    height = videoEl.videoHeight;
    width = videoEl.videoWidth;
  }

  isValidPhotoIDCanvas.setAttribute('id', 'test-canvas');
  isValidPhotoIDCanvas.setAttribute('height', `${height}`);
  isValidPhotoIDCanvas.setAttribute('width', `${width}`);

  const context: CanvasRenderingContext2D = isValidPhotoIDCanvas.getContext('2d');

  context.drawImage(videoEl, 0, 0);

  if (image?.width === 0 || width === 0 || height === 0) return { result: 'error' };
  let imageData = context.getImageData(0, 0, width, height);

  let result = null;
  const cb: any = proxy(privid_wasm_result);

  if (['900', '901', '902', '903'].includes(debugType)) {
    await createImages([imageData], ImageType.original, true);
  }
  if (image) {
    imageData = image;
  }

  try {
    if (isDocument) {
      if (doPredict) {
        configuration = JSON.stringify({
          ...configuration,
          document_check_validity: true,
          document_face_predict: true,
        });
      } else {
        configuration = JSON.stringify({
          ...configuration,
          document_check_validity: true,
          document_face_predict: false,
        });
      }

      result = await scanDocument(imageData, isSimd, cb, doPredict, configuration, debugType);
    } else {
      configuration = JSON.stringify(configuration);
      result = await isValidBarCode(imageData, isSimd, cb, configuration, debugType);
    }
    return { ...result, imageData };
  } catch (e) {
    printLogs('--------isValidPhotoID error', e, debugType);
    return {
      result: -1,
    };
  }
};

// eslint-disable-next-line consistent-return
export async function enroll1FA(
  callback: (input: {
    status: FaceStatuses;
    result?: number;
    message?: string;
    returnValue?: any;
    progress?: number;
    portrait?: Base64;
    livenessCheck?: number;
  }) => void,
  config?: { input_image_format: string; send_original_images?: boolean },
  livenessCheck?: boolean,
  image?: [ImageData],
) {
  const { os } = detect();
  printLogs('--------------------ENROLL_ONE_FA-----------------------', '', debugType);
  let portrait: Base64;
  let portraitConfidenceScore: number;
  // eslint-disable-next-line consistent-return
  const configJSON = JSON.stringify(config);
  if (image) {
    privid_wasm_result = createCallbackEnroll(callback);
    await FHE_enrollOnefa(image, isSimd, debugType, proxy(privid_wasm_result), configJSON);
    return;
  }

  const isIOS = iOS() || os === 'iOS';
  const originalImages: any[] = [];

  let numberOfImages = 10;

  if (isIOS) {
    numberOfImages = 2;
  }

  const canvas: HTMLCanvasElement = document.createElement('canvas');

  while (originalImages.length < numberOfImages) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-const
    const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
    printLogs('video element', videoEl, debugType);
    if (!videoEl) {
      printLogs('no video element found', '', debugType, LOGTYPE.ERROR);
      // eslint-disable-next-line consistent-return
      return { result: 'error' };
    }
    const height = videoEl.videoHeight;
    const width = videoEl.videoWidth;
    // eslint-disable-next-line consistent-return
    if (width === 0) return { result: 'error' };
    canvas.setAttribute('id', 'test-canvas');
    canvas.setAttribute('height', `${height}`);
    canvas.setAttribute('width', `${width}`);

    const context: CanvasRenderingContext2D = canvas.getContext('2d');

    context.drawImage(videoEl, 0, 0);

    let imageData = context.getImageData(0, 0, width, height);

    if (livenessCheck) {
      // if (!isAntispoofLoaded()) {
      //   await loadAntiSpoofModules();
      // }

      const result = await antispoofCheck(imageData.data, imageData.width, imageData.height);

      if (result?.livenessCheck === 0) {
        await isValidInternal(
          imageData.data,
          imageData.width,
          imageData.height,
          isSimd,
          debugType,
          proxy(
            createCallbackIsValid(async (res: any) => {
              if (res.returnValue.faces.length !== 0) {
                const { faces } = res.returnValue;
                let hasValidEnrollFace = false;
                for (let index = 0; faces.length > index; index++) {
                  const { status, box } = faces[index];
                  if (status === 0) {
                    const tempConfidenceScore = box.conf_score;
                    if (!portrait || tempConfidenceScore > portraitConfidenceScore) {
                      portraitConfidenceScore = tempConfidenceScore;
                      portrait = canvas.toDataURL("image/png");
                    }
                    hasValidEnrollFace = true;
                    originalImages.push(context.getImageData(0, 0, width, height));
                    callback({
                      status: FaceStatuses.VALID_FACE,
                      result: status,
                      progress: Math.round(Math.min((originalImages.length * 100) / numberOfImages, 100)),
                      livenessCheck: result?.livenessCheck,
                    });
                    index = faces.length;
                  }

                  if (index + 1 === faces.length && status !== 0 && !hasValidEnrollFace) {
                    callback({
                      status: FaceStatuses.INVALID_FACE,
                      result: status,
                      message: getStatusMessage(status),
                      livenessCheck: result?.livenessCheck,
                    });
                  }
                }
              }
            }, result?.livenessCheck),
          ),
          JSON.stringify({
            input_image_format: 'rgba',
            context_string: 'enroll',
          }),
        );
      } else {
        callback({
          status: FaceStatuses.INVALID_FACE,
          result: -1,
          message: 'No Face Detected',
          livenessCheck: result?.livenessCheck,
        });
      }
    } else {
      await isValidInternal(
        imageData.data,
        imageData.width,
        imageData.height,
        isSimd,
        debugType,
        proxy(
          createCallbackIsValid(async (result: any) => {
            if (result.returnValue.faces.length !== 0) {
              const { faces } = result.returnValue;
              let hasValidEnrollFace = false;
              for (let index = 0; faces.length > index; index++) {
                const { status, box } = faces[index];
                if (status === 0) {
                  const tempConfidenceScore = box.conf_score;
                  if (!portrait || tempConfidenceScore > portraitConfidenceScore) {
                    portraitConfidenceScore = tempConfidenceScore;
                    portrait = canvas.toDataURL("image/png");
                  }
                  hasValidEnrollFace = true;
                  originalImages.push(context.getImageData(0, 0, width, height));
                  callback({
                    status: FaceStatuses.VALID_FACE,
                    result: status,
                    progress: Math.round(Math.min((originalImages.length * 100) / numberOfImages, 100)),
                  });
                  index = faces.length;
                }

                if (index + 1 === faces.length && status !== 0 && !hasValidEnrollFace) {
                  callback({ status: FaceStatuses.INVALID_FACE, result: status, message: getStatusMessage(status) });
                }
              }
            }
          }),
        ),
        JSON.stringify({
          input_image_format: 'rgba',
          context_string: 'enroll',
        }),
      );
    }

    imageData = null;
    releaseCanvas(canvas);
  }

  privid_wasm_result = createCallbackEnroll(callback, portrait);

  await FHE_enrollOnefa(originalImages, isSimd, debugType, proxy(privid_wasm_result), configJSON);
  if (isDebugWithImages) {
    await createImages(originalImages, ImageType.original, true);
  }
  currentOperation = { operation: 'enroll' };
}

/**
 * This function performs faceLogin, the camera should already be open. the functions performs the identification and return the result. This function is more restrictive than predict1Fa.
 * @category Face
 * @param callback Callbacks triggered on the  `predict` operation
 * @param config Configuration recommeded default: { input_image_format: "rgba" }
 * @param element Element id of video tag. (Optional) By default it uses the element id used when opening the camera using openCamera()
 * @param livenessCheck Boolean, if true would load liveness module and check for liveness first before proceeding to predict
 */
export const faceLogin = async (
  callback: (input: {
    status: FaceStatuses;
    result?: number;
    returnValue?: any;
    progress?: number;
    portrait?: Base64;
  }) => void,
  config?: { input_image_format: string },
  element?: string,
  livenessCheck?: boolean,
  // eslint-disable-next-line consistent-return
) => {
  printLogs('---------------------PREDICT_ONE_FA----------------------', '', debugType);

  let configFinal: any = config || { input_image_format:"rgba" };
  const { os } = detect();
  if (['iOS', 'android', 'Android OS'].includes(os)) {
    configFinal = {
      ...configFinal,
      context_string: "login_mobile",
    };
  } else {
    configFinal = {
      ...configFinal,
      context_string: "login_desktop",
    };
  }

  const configJSON = JSON.stringify(configFinal);
  console.log("configJSON ",configFinal);
  if (element) {
    videoElement = element;
  }

  // eslint-disable-next-line consistent-return
  const originalImages: ImageData[] = [];
  const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
  const height = videoEl.videoHeight;
  const width = videoEl.videoWidth;

  // eslint-disable-next-line consistent-return
  if (width === 0) return { result: 'error' };
  printLogs('------ isValid', `${height} ${width}`, debugType);
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  canvas.setAttribute('id', 'test-canvas');
  canvas.setAttribute('height', `${height}`);
  canvas.setAttribute('width', `${width}`);

  const context: CanvasRenderingContext2D = canvas.getContext('2d');

  if (faceMode === CameraFaceMode.front) {
    context.translate(width, 0);
    context.scale(-1, 1);
  }

  context.drawImage(videoEl, 0, 0);
  const imageData = context.getImageData(0, 0, width, height);
  originalImages.push(imageData);

  if (livenessCheck) {
    // if (!isAntispoofLoaded()) {
    //   await loadAntiSpoofModules();
    // }
    const result = await antispoofCheck(imageData.data, imageData.width, imageData.height);
    privid_wasm_result = createCallbackPredict(callback, result?.livenessCheck);
    if (result?.livenessCheck === 0) {
      FHE_predictOnefa(originalImages, isSimd, debugType, proxy(privid_wasm_result), configJSON);
    } else {
      // @ts-ignore
      callback({ status: FaceStatuses.WASM_RESPONSE, livenessCheck: result?.livenessCheck });
    }
  } else {
    privid_wasm_result = createCallbackPredict(callback);
    FHE_predictOnefa(originalImages, isSimd, debugType, proxy(privid_wasm_result), configJSON);
  }
};

/**
 * This function performs predict, the camera should already be open. the functions performs the identification return the result then restart again.
 * @category Face
 * @param callback Callbacks triggered on the  `predict` operation
 * @param config Configuration recommeded default: { input_image_format: "rgba" }
 * @param element Element id of video tag. (Optional) By default it uses the element id used when opening the camera using openCamera()
 * @param livenessCheck Boolean, if true would check for liveness first before proceeding to predict
 * @param image ImageData, If there is an image passed, it will be predicting the image instead of the video feed.
 */

export const predict1FA = async (
  callback: (input: {
    status: FaceStatuses;
    result?: number;
    returnValue?: any;
    progress?: number;
    portrait?: Base64;
  }) => void,
  config?: { input_image_format: string },
  element?: string,
  livenessCheck?: boolean,
  image?: [ImageData],
  // eslint-disable-next-line consistent-return
) => {
  printLogs('---------------------PREDICT_ONE_FA----------------------', '', debugType);

  const configJSON = JSON.stringify(config);
  if (image) {
    privid_wasm_result = createCallbackPredict(callback);
    await FHE_predictOnefa(image, isSimd, debugType, proxy(privid_wasm_result), configJSON);
    return;
  }

  if (element) {
    videoElement = element;
  }

  // eslint-disable-next-line consistent-return
  const originalImages: ImageData[] = [];
  const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
  const height = videoEl.videoHeight;
  const width = videoEl.videoWidth;

  // eslint-disable-next-line consistent-return
  if (width === 0) return { result: 'error' };
  printLogs('------ isValid', `${height} ${width}`, debugType);
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  canvas.setAttribute('id', 'test-canvas');
  canvas.setAttribute('height', `${height}`);
  canvas.setAttribute('width', `${width}`);

  const context: CanvasRenderingContext2D = canvas.getContext('2d');

  if (faceMode === CameraFaceMode.front) {
    context.translate(width, 0);
    context.scale(-1, 1);
  }

  context.drawImage(videoEl, 0, 0);
  const imageData = context.getImageData(0, 0, width, height);
  originalImages.push(imageData);

  if (livenessCheck) {
    // if (!isAntispoofLoaded()) {
    //   await loadAntiSpoofModules();
    // }
    const result = await antispoofCheck(imageData.data, imageData.width, imageData.height);
    privid_wasm_result = createCallbackPredict(callback, result?.livenessCheck);
    if (result?.livenessCheck === 0) {
      FHE_predictOnefa(originalImages, isSimd, debugType, proxy(privid_wasm_result), configJSON);
    } else {
      // @ts-ignore
      callback({ status: FaceStatuses.WASM_RESPONSE, livenessCheck: result?.livenessCheck });
    }
  } else {
    privid_wasm_result = createCallbackPredict(callback);
    FHE_predictOnefa(originalImages, isSimd, debugType, proxy(privid_wasm_result), configJSON);
  }
};

let stopContinuousAuth = false;
/**
 * This function is a utility function for continuiousAuthentication. To stop the continuiousAuthentication please provide true, to start again the continuious predict/enroll use this again and provide false.
 * @category Face
 * @param loop The loop to be triggered, boolean `true` for stopping continuious predict/enroll and `false` starting for continuious predict/enroll again.
 */
export const setStopLoopContinuousAuthentication = (loop: boolean) => {
  stopContinuousAuth = loop;
};
/**
 * This function performs continuious predict, the camera should already be open. the functions performs the identification return the result then restart again.
 * @category Face
 * @param callback Callbacks triggered on the  `predict` operation
 * @param config Configuration recommeded default: { input_image_format: "rgba" }
 * @param element Element id of video tag. (Optional) By default it uses the element id used when opening the camera using openCamera()
 */
// eslint-disable-next-line consistent-return
export async function continuousAuthentication(
  callback: (input: {
    status: FaceStatuses;
    result?: number;
    returnValue?: any;
    progress?: number;
    age?: number;
  }) => void,
  config?: { input_image_format: string },
  element?: string,
) {
  printLogs('---------------------continuousPredict----------------------', '', debugType);
  if (element) {
    videoElement = element;
  }
  await predict1FA(
    async (result) => {
      callback(result);
      if (!stopContinuousAuth) {
        continuousAuthentication(callback, config, videoElement);
      }
    },
    {
      input_image_format: 'rgba',
    },
  );
}

const getDefaultDevice = (devices: MediaDeviceInfo[], device: string) =>
  devices.reduce((acc, val) => {
    if (val.deviceId === device) {
      // @ts-ignore
      if (val.getCapabilities) {
        // @ts-ignore
        acc.push(val.getCapabilities());
      } else {
        acc.push(val);
      }
    }
    return acc;
  }, []);

export async function faceISO(
  callback: (input: {
    status: FaceStatuses;
    result?: number;
    returnValue?: any;
    progress?: number;
    portrait?: Base64;
  }) => void,
  config?: { input_image_format: string },
) {
  let portrait: Base64;
  let originalImages: ImageData[] = [];
  while (originalImages.length < 1) {
    // eslint-disable-next-line prefer-const
    let isValidResult = false;
    const videoEl: HTMLVideoElement = document.getElementById(videoElement) as HTMLVideoElement;
    printLogs('video element', videoEl, debugType);
    if (!videoEl) {
      printLogs('no video element found', '', debugType, LOGTYPE.ERROR);
      return { result: 'error' };
    }
    const height = videoEl.videoHeight;
    const width = videoEl.videoWidth;

    if (width === 0) return { result: 'error' };
    const canvas = document.createElement('canvas');
    canvas.setAttribute('id', 'test-canvas');
    canvas.setAttribute('height', `${height}`);
    canvas.setAttribute('width', `${width}`);

    const context: CanvasRenderingContext2D = canvas.getContext('2d');
    context.drawImage(videoEl, 0, 0);

    const imageData = context.getImageData(0, 0, width, height);

    await isValid(async (result) => {
      if (result.returnValue.faces !== 0) {
        const { faces } = result.returnValue;
        for (let index = 0; faces.length > index; index++) {
          isValidResult = true;
        }
      }
    }, imageData);
    if (isValidResult) {
      originalImages.push(imageData);
    }
  }

  console.log('original ImageData:', originalImages);

  // eslint-disable-next-line prefer-const
  portrait = await getPortraitBase64(originalImages[0]);
  privid_wasm_result = createResultFaceISO(callback, portrait);

  const configJSON = JSON.stringify(config);
  const { result, imageOutput } = await prividFaceISO(
    originalImages[0],
    isSimd,
    debugType,
    proxy(privid_wasm_result),
    configJSON,
  );
  originalImages = null;
  return { result, imageOutput };
}

export const faceCompareLocal = async (
  callback: (input: { result?: number }) => void,
  imageDataA: ImageData,
  imageDataB: ImageData,
  config?: { input_image_format: string },
) => {
  privid_wasm_result = createCallbackFaceCompare(callback);

  const configJSON = JSON.stringify(config);
  const result = await prividFaceCompareLocal(
    imageDataA,
    imageDataB,
    isSimd,
    debugType,
    proxy(privid_wasm_result),
    configJSON,
  );

  return result;
};

function releaseCanvas(canvas: HTMLCanvasElement) {
  try {
    console.log('---- STARTING TO RELEASE CANVAS -----');
    // eslint-disable-next-line no-param-reassign
    canvas.width = 1;
    // eslint-disable-next-line no-param-reassign
    canvas.height = 1;
    const ctx = canvas.getContext('2d');
    // eslint-disable-next-line no-unused-expressions
    ctx && ctx.clearRect(0, 0, 1, 1);
    // eslint-disable-next-line no-param-reassign
    canvas = null;
    console.log('---- CANVAS RELEASED -----');
  } catch (e) {
    console.log('____clearing canvas', e);
  }
}
